import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
// import { LoggingService } from '../logging.service';
import { ManualAdjustmentFeatureComponent } from './manual-adjustment-feature/manual-adjustment-feature.component';

// const log = new LoggingService();

export const ManualAdjustmentRoute: Ng2StateDeclaration = {
    name: 'manualtxn',
    url: '/manualtxn',
    data: { requiresAuth: true },

    component: ManualAdjustmentFeatureComponent
};
